import { render, staticRenderFns } from "./NetworkBanner.vue?vue&type=template&id=2672cda8&scoped=true&"
import script from "./NetworkBanner.vue?vue&type=script&lang=js&"
export * from "./NetworkBanner.vue?vue&type=script&lang=js&"
import style0 from "./NetworkBanner.vue?vue&type=style&index=0&id=2672cda8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2672cda8",
  null
  
)

export default component.exports